export type WhatsappReauthEvaluation =
  | { ok: true }
  | { ok: false; reason: "WABA_MISMATCH" | "PHONE_MISMATCH" };

/**
 * Decide whether a WhatsApp reauthorization result can be applied to the bound
 * channel. Mirrors the guard previously inlined in General.tsx, but returns a
 * reason so the UI can show a specific failure message.
 *
 * - WABA_MISMATCH: Meta returned a different WhatsApp Business Account than the
 *   one bound to this channel (e.g. the number was re-onboarded into a new WABA).
 *   This currently cannot be updated in place.
 * - PHONE_MISMATCH: (non-coexistence only) the returned phone number id differs.
 */
export function evaluateWhatsappReauthResult(params: {
  boundWabaId: string | undefined;
  boundExternalChannelId: string | null;
  returnedWabaId: string;
  returnedPhoneNumberId: string;
  coexistenceEnabled: boolean;
}): WhatsappReauthEvaluation {
  const {
    boundWabaId,
    boundExternalChannelId,
    returnedWabaId,
    returnedPhoneNumberId,
    coexistenceEnabled,
  } = params;

  if (boundWabaId !== returnedWabaId) {
    return { ok: false, reason: "WABA_MISMATCH" };
  }
  if (!coexistenceEnabled && boundExternalChannelId !== returnedPhoneNumberId) {
    return { ok: false, reason: "PHONE_MISMATCH" };
  }
  return { ok: true };
}
